import DeleteImg from "../../../assets/images/myaccount/delete-acc-image.png";
import PrimaryBtn from "../../button/PrimaryBtn";
import SecondaryBtn from "../../button/SecondaryBtn";
import { useTranslation } from "react-i18next";
import { useMutation } from "@tanstack/react-query";
import { deleteAccountAPI } from "../../../api/auth";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { closeModal } from "../../../redux/slices/uiSlice";

const DeleteAccountModal = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { mutate: deleteAccount, isPending } = useMutation({
    mutationFn: deleteAccountAPI,
    onSuccess: () => {
      localStorage.removeItem("token");
      sessionStorage.removeItem("token");
      navigate("/");
      dispatch(closeModal());
    },
  });
  const handleDeleteAccount = () => {
    deleteAccount();
  };
  return (
    <>
      <div className="fixed inset-0 bg-black/80 flex items-center justify-center lg:p-[1%] p-4 z-50">
        <div className="modal bg-white-500 lg:rounded-[1.5vw] rounded-3xl lg:p-[2vw] md:p-7 p-4 lg:max-w-[35vw] md:max-w-[543] max-w-116 w-full relative animate-[slideUp_0.3s_ease-out] lg:border-[0.2vw] border-3 border-primary auth-page overflow-auto lg:max-h-[calc(100dvh-11%)] max-h-[calc(100dvh-40px)] hide-scroll">
          <div className="flex lg:gap-[1vw] gap-2 items-start justify-between w-full lg:mb-[1vw] md:mb-0 mb-3">
            {/* Close Button */}
            {/* <button
              onClick={onClose}
              className="lg:w-[1.2vw] lg:h-[1.2vw] md:w-5 w-4 md:h-5 h-4 flex items-center justify-center cursor-pointer ms-auto lg:mb-6 md:mb-4 mb-2 hover:scale-110 transition-transform duration-300"
            >
              <svg
                className="w-full h-full"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.9474 12.1123C15.8856 12.0504 15.8856 11.9496 15.9474 11.8878L23.5029 4.3286C24.149 3.68231 24.149 2.63063 23.5029 1.98429L22.0051 0.48573C21.692 0.172468 21.2758 0 20.833 0C20.3902 0 19.9739 0.172468 19.6609 0.485683L12.1054 8.04493C12.0672 8.08316 12.0235 8.09122 11.9937 8.09122C11.9639 8.09122 11.9203 8.08321 11.8821 8.04493L4.32658 0.485683C4.01351 0.172468 3.59726 0 3.15445 0C2.71164 0 2.29544 0.172468 1.98236 0.485683L0.484547 1.98429C-0.161516 2.63063 -0.161516 3.68231 0.484547 4.3286L8.04001 11.8878C8.10185 11.9496 8.10185 12.0504 8.04001 12.1123L0.484547 19.6714C-0.161469 20.3178 -0.161469 21.3694 0.484547 22.0157L1.98236 23.5143C2.29544 23.8275 2.71168 24 3.15445 24C3.59721 24 4.01351 23.8275 4.32658 23.5143L11.882 15.9551C11.9203 15.9169 11.9638 15.9089 11.9937 15.9089C12.0235 15.9089 12.0671 15.9169 12.1053 15.9552L19.6608 23.5143C19.9739 23.8276 20.3901 24 20.8329 24C21.2758 24 21.692 23.8276 22.005 23.5143L23.5028 22.0158C24.1489 21.3695 24.1489 20.3178 23.5028 19.6715L15.9474 12.1123Z"
                  fill="#333938"
                />
              </svg>
            </button> */}
          </div>
          {/* Header */}
          <div className="text-center">
            <img
              src={DeleteImg}
              alt=""
              className="mx-auto 2xl:max-w-[6.67vw] max-w-32 w-full 2xl:mb-[2.5vh] md:mb-6 mb-4 rtl:-scale-x-100"
            />
            <h1 className="lg:text-[1.9vw]/[2.2vw] text-2xl/6 font-bold text-[#EF5350] lg:mb-[0.3vw] mb-2">
              {t("deleteAccountModal.deleteAccount")}
            </h1>
            <p className="lg:text-[1.1vw]/[1.4vw] text-base/tight text-black-800 lg:mb-[1.1vw] md:mb-5 mb-4 font-bold">
              {t("deleteAccountModal.areYouSureYouWantToDeleteAccount")}
            </p>
            <div className="flex justify-center 2xl:gap-[0.78vw] md:gap-3.5 gap-2">
              <SecondaryBtn onClick={() => dispatch(closeModal())}>
                {t("deleteAccountModal.cancel")}
              </SecondaryBtn>
              {/* <RedBtn className="2xl:!min-w-[calc(50%-0.12rem)] md:!min-w-[calc(50%-7px)] !min-w-[calc(50%-4px)] px-3 ![background:padding-box_linear-gradient(to_bottom,#E9E9E9,#C0C0C0),_border-box_linear-gradient(to_bottom,#E9E9E9,#B3B5B4)]">Cancel</RedBtn> */}
              <PrimaryBtn onClick={handleDeleteAccount} isLoading={isPending}>
                {t("deleteAccountModal.yesDelete")}
              </PrimaryBtn>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default DeleteAccountModal;
